import script from "./SoffitFascia04Composite.vue?vue&type=script&setup=true&lang=js"
export * from "./SoffitFascia04Composite.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__